// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-match-edit-main-info-modal .modal2__container {
    width: 400px;
}

.tournament-match-edit-main-info__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
}

.tournament-match-edit-main-info__header .hubicon-clear_option {
    cursor: pointer;
}

.tournament-match-edit-main-info__input {
    padding: 32px 20px;
    border-top: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament-match-edit-main-info__input .input-field {
    margin: 0;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.tournament-match-edit-main-info__input .input-field-input {
    background: var(--white-color);
}

.tournament-match-edit-main-info__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 8px 12px;
}

.tournament-match-edit-main-info__actions .button {
    font-size: 16px;
    line-height: 19px;
    padding: 10px 12px;
}

.tournament-match-edit-main-info__actions .secondary-button {
    border: none;
    color: var(--basic-gray-color);
}

.tournament-match-edit-main-info__actions .secondary-button:hover,
.tournament-match-edit-main-info__actions .secondary-button:focus,
.tournament-match-edit-main-info__actions .secondary-button:active {
    background-color: transparent;
    color: var(--basic-gray-color);
}

.tournament-match-edit-main-info__input .MuiFormControl-root.select-action-btn__container.select-action-btn__container .MuiInputBase-root {
    width: 100%;
}

.tournament-match-edit-main-info__input .select-action-btn__container .MuiAutocomplete-popper.MuiAutocomplete-popperDisablePortal {
    position: fixed !important;
    inset: unset !important;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-match-edit-main-info-modal/TournamentMatchEditMainInfoModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,yDAAyD;AAC7D;;AAEA;IACI,SAAS;IACT,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,8BAA8B;AAClC;;AAEA;;;IAGI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B","sourcesContent":[".tournament-match-edit-main-info-modal .modal2__container {\n    width: 400px;\n}\n\n.tournament-match-edit-main-info__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 24px;\n}\n\n.tournament-match-edit-main-info__header .hubicon-clear_option {\n    cursor: pointer;\n}\n\n.tournament-match-edit-main-info__input {\n    padding: 32px 20px;\n    border-top: 1px solid var(--new-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-match-edit-main-info__input .input-field {\n    margin: 0;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.tournament-match-edit-main-info__input .input-field-input {\n    background: var(--white-color);\n}\n\n.tournament-match-edit-main-info__actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 8px 12px;\n}\n\n.tournament-match-edit-main-info__actions .button {\n    font-size: 16px;\n    line-height: 19px;\n    padding: 10px 12px;\n}\n\n.tournament-match-edit-main-info__actions .secondary-button {\n    border: none;\n    color: var(--basic-gray-color);\n}\n\n.tournament-match-edit-main-info__actions .secondary-button:hover,\n.tournament-match-edit-main-info__actions .secondary-button:focus,\n.tournament-match-edit-main-info__actions .secondary-button:active {\n    background-color: transparent;\n    color: var(--basic-gray-color);\n}\n\n.tournament-match-edit-main-info__input .MuiFormControl-root.select-action-btn__container.select-action-btn__container .MuiInputBase-root {\n    width: 100%;\n}\n\n.tournament-match-edit-main-info__input .select-action-btn__container .MuiAutocomplete-popper.MuiAutocomplete-popperDisablePortal {\n    position: fixed !important;\n    inset: unset !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
